import React, { FC, ReactNode, useMemo } from "react";
// 组件
import { MenuOutlined } from "@ant-design/icons";
import { ProForm, ProInputNumber } from "../../antd";
// 方法
import { useSortable } from '@dnd-kit/sortable';
// 常量
import { CSS } from '@dnd-kit/utilities';
import { STATUS_CREATED, STATUS_CREATED_CODE } from "../../constants/constant";
import { EditableRowProps, GROUP_NAME, SORT_DATA_INDEX } from "../interface";

const MoveEditableRow: FC<EditableRowProps> = props => {
  const { children, 'data-row-key': rowKey, move, index, ...restProps } = props;
  if (rowKey === undefined || index === undefined) return <tr {...restProps} children={children} />;
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: index + 1,
  });
  const rowChildren: ReactNode[] | null = useMemo(() => {
    if (!children) return null;
    const newChildren: ReactNode[] = [];
    if (Array.isArray(children) && children.length) {
      children.forEach(child => {
        if (child?.props?.dataIndex === SORT_DATA_INDEX) {
          newChildren.push(React.cloneElement(child as React.ReactElement, {
            children: (
              <MenuOutlined
                ref={setActivatorNodeRef}
                style={{ touchAction: 'none', cursor: 'move' }}
                {...listeners}
              />
            ),
          }));
        } else {
          newChildren.push(child);
        }
      });
      newChildren.push(
        <ProForm.Item key='row-status' name={[GROUP_NAME, rowKey, STATUS_CREATED_CODE]} hidden initialValue={STATUS_CREATED.DEFAULT}>
          <ProInputNumber />
        </ProForm.Item>
      );
    }
    return newChildren;
  }, [children]);
  const style: React.CSSProperties = {
    ...props.style,
    transform: CSS.Transform.toString(transform && { ...transform, scaleY: 1 }),
    transition,
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  };

  if (!rowChildren) return null;
  return (
    <tr {...restProps} data-row-key={rowKey} ref={setNodeRef} style={style} children={rowChildren} {...attributes} />
  );
};

export default MoveEditableRow;
